import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppEditIcon } from "../../Icon/AppEditIcon";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

type IEditToolButtonProps = IconButtonProps & {
    openButton?: boolean
    tooltip?: string;
}

export const EditToolButton = ({ openButton, tooltip, ...props }: IEditToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={tooltip ?? (openButton ? Translations.Open : Translations.Edit)}
        icon={openButton ? <OpenInNewIcon /> : <AppEditIcon />}
    />
);
